// extracted by mini-css-extract-plugin
module.exports = {"comment_author__inline":"reviewerProfile_comment_author__inline__1Upqd","comment_author":"reviewerProfile_comment_author__9__Z8","wrapper":"reviewerProfile_wrapper__34e8w"};